import ResizeObserver from "resize-observer-polyfill";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// Set up axios interceptors for global error handling (must be imported early)
import "./utils/axiosSetup.js";
import App from "./App.js";
import { AuthProvider } from "./utils/AuthContext.js";
import { ThemeProvider } from "@mui/material";
import { Theme } from "./styles/Theme.js";
import { SnackbarProvider, Snackbar } from "src/utils/SnackbarContext.js";
import { ErrorBoundary, ErrorComponent } from "./utils/ErrorBoundary/index.js";
import StripeWrapper from "./components/StripeWrapper.js";

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ThemeProvider theme={Theme}>
    <ErrorBoundary fallback={<ErrorComponent />}>
      <SnackbarProvider>
        <AuthProvider>
          <StripeWrapper>
            <Snackbar />
            <App />
          </StripeWrapper>
        </AuthProvider>
      </SnackbarProvider>
    </ErrorBoundary>
  </ThemeProvider>
);
